// Forward-compatible client instrumentation entry for Next.js / Turbopack
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/blog/:slug\",\"regex\":\"^/blog/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/concept/landing/:id\",\"regex\":\"^/concept/landing/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/proposals/audere/prototype/:slug*?\",\"regex\":\"^/proposals/audere/prototype(?:/(.*))?$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/audere\"},{\"path\":\"/blog\"},{\"path\":\"/changelog\"},{\"path\":\"/concept\"},{\"path\":\"/concept/contact\"},{\"path\":\"/concept/landing\"},{\"path\":\"/concept/render\"},{\"path\":\"/concept/share-card\"},{\"path\":\"/connect/stripe\"},{\"path\":\"/hpt\"},{\"path\":\"/one\"},{\"path\":\"/pricing\"},{\"path\":\"/privacy\"},{\"path\":\"/proposals/audere\"},{\"path\":\"/research\"},{\"path\":\"/support\"},{\"path\":\"/terms\"}],\"isrRoutes\":[\"/blog/:slug\",\"/proposals/audere/prototype/:slug*?\"]}";globalThis["_sentryNextJsVersion"] = "16.3.1";import * as Sentry from "@sentry/nextjs";
import posthog from "posthog-js";
import { env } from "./src/env";
import "./sentry.client.config";

const postHogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const configuredAppUrl = env.NEXT_PUBLIC_APP_URL?.trim();
let shouldInitPosthog = process.env.NODE_ENV === "production";

if (shouldInitPosthog && configuredAppUrl && typeof window !== "undefined") {
  try {
    const expectedOrigin = new URL(configuredAppUrl).origin;
    shouldInitPosthog = window.location.origin === expectedOrigin;
    if (!shouldInitPosthog) {
      console.error(
        "[posthog] client analytics disabled: current origin does not match production app origin.",
        {
          currentOrigin: window.location.origin,
          expectedOrigin,
        },
      );
    }
  } catch (error) {
    shouldInitPosthog = false;
    console.error(
      "[posthog] invalid NEXT_PUBLIC_APP_URL; analytics disabled.",
      {
        configuredAppUrl,
        error,
      },
    );
  }
} else if (!configuredAppUrl) {
  shouldInitPosthog = false;
  console.error(
    "[posthog] NEXT_PUBLIC_APP_URL is missing; analytics disabled outside explicit production origin.",
  );
}

if (postHogKey && shouldInitPosthog) {
  posthog.init(postHogKey, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    ui_host: "https://eu.posthog.com",
    defaults: "2025-11-30",
    capture_pageleave: true,
    person_profiles: "identified_only",
  });
} else if (!postHogKey) {
  console.error(
    "[posthog] NEXT_PUBLIC_POSTHOG_KEY is not set; analytics is disabled on the client.",
  );
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
